export default __webpack_public_path__ + "static/media/envelope.692084a4.svg";